import { render } from "./takeaway_component.vue?vue&type=template&id=d30893c6"
import script from "./takeaway_component.vue?vue&type=script&lang=js"
export * from "./takeaway_component.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__